<div class="d-flex flex-column invite-social-modal">
    <ng-container *ngIf="referral_social$ | async as config">
        <h3 *ngIf="config.title">
            {{ config.title }}
        </h3>
    </ng-container>
    
    <serviceos-web-referral-social
        [referralsOptions]="referral_social$ | async"
        [visualType]="'button'"
        (onEvent)="onSocialEvent($event)">
    </serviceos-web-referral-social>
</div>